import React from "react";
import {Switch, Route} from 'react-router-dom';

// components
import ListDealer from "./ListDealer";
import DealerDetails from "./DealerDetails";

class Dealers extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route exact path={this.props.match.path} render={(props) => <ListDealer {...props}/>} />
        <Route path={`${this.props.match.path}/:dealerId`}  render={(props) => <DealerDetails {...props}/>} />
      </Switch>
    );
  }
}

export default Dealers;